import Button from "@common/components/Button";
import Dialog from "@common/components/Dialog";
import DialogActions from "@common/components/Dialog/DialogActions";
import DialogTitle from "@common/components/Dialog/DialogTitle";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import {
  CircularProgress,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { getMeetingElog, putMeetingElog } from "@services/meetings";
import { MeetingElog } from "@services/meetings/types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useErrorNotification } from "@common/components/Notification";

type ConfirmUnwrapDialogProps = {
  open: boolean;
  onClose: Function;
};

const ConfirmUnwrapDialog = (props: ConfirmUnwrapDialogProps) => {
  const { open, onClose } = props;
  const context = React.useContext(RoomsRealtimeContext);
  const dispatchError = useErrorNotification();
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [elog, setElog] = useState<MeetingElog>();
  const refetch = async (id: number) => {
    try {
      setLoading(true);
      setElog(await getMeetingElog(id));
    } catch (e) {
      dispatchError(e);
    } finally {
      setLoading(false);
    }
  };
  const confirmUnwrapMeeting = async () => {
    try {
      if (elog)
        await putMeetingElog(context.detail?.meeting?.id, {
          ...elog,
          wrappedUp: false,
        });
      context.detail?.refetch();
      onClose();
    } catch (e) {
      dispatchError(e);
    }
  };
  useEffect(() => {
    if (context.detail?.meeting?.id !== undefined)
      refetch(context.detail?.meeting?.id);
  }, [context.detail?.meeting?.id]);

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{t("Undo Wrap Up")}</DialogTitle>
      <DialogContent>
        {context.detail?.meeting === undefined ||
        elog === undefined ||
        loading ? (
          <CircularProgress />
        ) : (
          <DialogContentText>
            {t("Please confirm you want to reopen this meeting for reporting?")}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="greyed" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button color="error" onClick={() => confirmUnwrapMeeting()}>
          Undo Wrap Up
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmUnwrapDialog;
